/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export default function DurationPicker({ input: { value, onChange }, meta: { error }, disabled }) {
  const [initDuration, initTimeType] = value.split(' ');
  const [duration, setDuration] = useState(initDuration);
  const [timeType, setTimeType] = useState(initTimeType);
  const [isDisabled, setIsDisabled] = useState(disabled || initTimeType === 'Continuous');

  useEffect(() => {
    onChange(`${duration} ${timeType}`);
  }, [duration, timeType, onChange]);

  useEffect(() => {
    setIsDisabled(disabled);
  }, [disabled]);

  const handleChange = ({ target: { type, value: val } }) => {
    switch (type) {
      case 'text':
        setDuration(val);
        break;

      case 'timeType':
        setTimeType(val);
        break;

      case 'select-one':
        if (val === 'Continuous') {
          setIsDisabled(true);
          setDuration('');
          setTimeType(val);
          break;
        }
        setIsDisabled(false);
        setTimeType(val);
        break;

      default:
        break;
    }
  };
  return (
    <div>
      <input
        type="text"
        name="duration"
        style={{
          ...inputStyle,
          borderColor: error ? '#f00' : '#dcdddf',
          background: disabled ? 'whitesmoke' : '#fff',
        }}
        value={duration}
        onChange={handleChange}
        disabled={isDisabled}
        autoComplete="off"
      />
      <select
        name="timeType"
        style={{
          ...selectStyle,
          borderColor: error ? '#f00' : '#dcdddf',
          background: disabled ? 'whitesmoke' : '#fff',
        }}
        value={timeType}
        onChange={handleChange}
        disabled={isDisabled}
      >
        <option />
        <option value="Minutes">Minutes</option>
        <option value="Hours">Hours</option>
        <option value="Days">Days</option>
        <option value="Continuous">Continuous</option>
      </select>
      {error && <p style={pStyle}>{error}</p>}
    </div>
  );
}

DurationPicker.prototype = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }),
};

const pStyle = {
  color: '#f00',
  fontSize: '0.75rem',
};

const inputStyle = {
  background: '#fff',
  border: '0.063rem solid #dcdddf',
  fontFamily: 'Lato, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  outline: '0',
  padding: '0.438rem 1rem',
  transition: 'border-color 0.3s ease',
  width: '65%',
  marginRight: '5%',
};

const selectStyle = {
  background: '#fff',
  border: '0.063rem solid #dcdddf',
  fontFamily: 'Lato, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  outline: '0',
  padding: '0.438rem 1rem',
  transition: 'border-color 0.3s ease',
  width: '30%',
  height: '100%',
};
